(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3688],{

/***/ 63688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cms_CMS_CardImageText; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(12073);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Card/Card.module.scss
var Card_module = __webpack_require__(94634);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Card/Card.jsx











var CardContent = function(param) {
    var data = param.data, handleBtnClick = param.handleBtnClick;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 639
    });
    var image = data.image, layout = data.layout, title = data.title, content = data.content, button = data.button, alignment = data.alignment, background_color = data.background_color, text_color = data.text_color;
    var withButton = button.link && button.text;
    var noBackground = background_color === "no"; //No tiene background
    //@TODO Need to maintain old keys (CARD_*) to ensure backward compatbility with Wagtail pages
    // created before 2020-10-21 (and until all pages are updated)
    //LAYOUTS:
    var imageTop = layout === "image_top" || layout === "CARD_IMAGE_TOP";
    var imageSideRight = layout === "image_side" && alignment === "right" || layout === "CARD_IMAGE_RIGHT";
    var imageSideLeft = layout === "image_side" && alignment === "left" || layout === "CARD_IMAGE_LEFT";
    var imageSide = imageSideRight || imageSideLeft;
    var imageDescription = layout === "description_form" || layout === "CARD_IMAGE_FORM_BOTTOM_LEFT";
    var imageBlog = layout === "blog";
    var left = alignment === "left";
    var center = alignment === "center";
    var right = alignment === "right";
    /** *** CONTAINER CLASSNAMES */ var cardContainer = classnames_default()("flex flex-col duration-300 ease-out rounded-md relative h-full", (Card_module_default()).cardWrapper, {
        "sm:flex-row": !imageTop,
        "sm:flex-row-reverse group": imageSideRight,
        "sm:flex-row group": imageSideLeft,
        "cursor-pointer hover:shadow-down": withButton && imageTop || withButton && imageDescription || imageBlog
    });
    /** *** IMAGE CLASSNAMES */ var classnamesImageDescription = "w-auto sm:w-full rounded-tl-md rounded-tr-md rounded-none sm:rounded-md";
    var classnamesImageBlog = "w-full rounded-none sm:rounded-tr-md sm:rounded-br-md sm:rounded-l-none";
    var classnamesImageTop = "w-full rounded-tl-md rounded-tr-md rounded-b-none";
    var classnamesImageSide = classnames_default()("rounded-t-md rounded-b-none", {
        "cursor-pointer group-hover:shadow-down": withButton,
        "sm:rounded-t-none sm:rounded-l-md sm:rounded-r-none": imageSideLeft,
        "sm:rounded-t-none sm:rounded-l-none sm:rounded-r-md": imageSideRight
    });
    var _obj;
    var imageClass = classnames_default()("bg-center bg-cover bg-no-repeat duration-300", (_obj = {}, (0,_define_property/* default */.Z)(_obj, classnamesImageDescription, imageDescription), (0,_define_property/* default */.Z)(_obj, classnamesImageBlog, imageBlog), (0,_define_property/* default */.Z)(_obj, classnamesImageTop, imageTop), (0,_define_property/* default */.Z)(_obj, classnamesImageSide, imageSide), _obj));
    /** *** CARD CLASSNAMES */ var classnamesCardImageBlog = classnames_default()("absolute text-left rounded-tr-md rounded-tl-md rounded-b-none bottom-0 pt-4 sm:pt-6 mr-auto sm:mr-4", "left-1/2 sm:left-auto right-auto sm:right-0 transform -translate-x-1/2 sm:-translate-x-0");
    var classnamesCardImageTop = classnames_default()("h-full rounded-bl-md rounded-br-md rounded-t-none justify-between flex flex-col", {
        "text-center": center,
        "text-left": left,
        "text-right": right
    });
    var classnamesCardImageSide = "text-left justify-center items-start flex flex-col rounded-none sm:rounded-l-md";
    var classnamesCardImageDescription = classnames_default()("sm:absolute transform-none sm:transform", {
        "text-left": left,
        "text-center": center,
        "text-right": right,
        // IMAGE DESCRIPTION WITHOUT BACKGROUND COLOR
        "bottom-0 left-0": noBackground && left,
        "bottom-0 right-0": noBackground && right,
        "top-1/2 left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2": noBackground && center,
        // IMAGE DESCRIPTION WITH BACKGROUND COLOR
        "sm:top-1/2 sm:-translate-y-1/2 sm:rounded-r-md sm:rounded-l-none": !noBackground && left,
        "sm:top-1/2 sm:right-0 sm:-translate-y-1/2 sm:rounded-l-md sm:rounded-r-none": !noBackground && right,
        "sm:bottom-0 sm:left-1/2 sm:-translate-x-1/2 sm:rounded-t-md sm:rounded-b-none": !noBackground && center
    });
    var _obj1;
    var cardClass = classnames_default()("p-2 sm:p-4", (Card_module_default()).card, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, classnamesCardImageBlog, imageBlog), (0,_define_property/* default */.Z)(_obj1, classnamesCardImageTop, imageTop), (0,_define_property/* default */.Z)(_obj1, classnamesCardImageSide, imageSide), (0,_define_property/* default */.Z)(_obj1, classnamesCardImageDescription, imageDescription), _obj1));
    var setContainerHeight = {
        minHeight: imageSide ? "209px" : imageDescription ? "289px" : imageBlog && !isMobile ? "310px" : imageBlog && isMobile ? "275px" : "",
        height: imageTop && "100%"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cardContainer,
        style: setContainerHeight,
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("relative w-full", {
                    "min-w-1/2": imageSide,
                    "pb-36": imageTop || !imageBlog && isMobile,
                    "min-h-88": imageSide && !isMobile,
                    "min-h-68": imageBlog && isMobile
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    className: imageClass,
                    alt: title,
                    src: image,
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center",
                    quality: 70
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(cardClass, {
                    "min-w-auto sm:min-w-2/3 sm:max-w-10/12 lg:min-w-3/4 xl:min-w-2/3": imageDescription,
                    "w-5/6 sm:w-3/4": imageBlog
                }),
                style: {
                    minWidth: imageSide ? "47%" : "",
                    minHeight: imageBlog ? "150px" : imageTop && !withButton && !isMobile ? "164px" : "",
                    backgroundColor: background_color === "yes" && !imageBlog ? "#FCFCFC" : background_color === "no" ? "transparent" : imageBlog ? "rgba(252,252,252,.95)" : background_color,
                    color: text_color ? text_color : "#100C17"
                },
                children: [
                    imageBlog && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("mb-2 flex items-baseline justify-between sm:mb-4", (Card_module_default()).category),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-1 mb-0 font-body text-small font-body-regular",
                                children: "Leer m\xe1s"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                className: "ml-2 w-5"
                            })
                        ]
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: classnames_default()("mb-2 font-heading text-h3 font-heading-medium", {
                            "text-left": imageSide
                        }),
                        children: title
                    }),
                    !imageBlog && content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2",
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    }),
                    withButton && !imageBlog && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: classnames_default()("mt-0 w-full px-3 leading-4", {
                            "group-hover:shadow-down": withButton && imageSide,
                            "mx-auto block": alignment === "center",
                            "self-start": alignment === "left",
                            "self-end": alignment === "right",
                            "w-auto": imageDescription
                        }),
                        style: {
                            maxWidth: "190px"
                        },
                        size: "full",
                        onClick: handleBtnClick(button.link),
                        children: button.text
                    })
                ]
            })
        ]
    });
};
var Card = function(param) {
    var cardInfo = param.cardInfo, handleBtnClick = param.handleBtnClick;
    var cardButton = cardInfo.button.link;
    if (cardButton) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
        underline: false,
        href: cardButton,
        className: "h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent, {
            data: cardInfo,
            handleBtnClick: handleBtnClick
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent, {
        data: cardInfo,
        handleBtnClick: handleBtnClick
    });
};
Card.propTypes = {
    cardInfo: prop_types.object,
    handleBtnClick: prop_types.func.isRequired
};
/* harmony default export */ var Card_Card = (Card);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Card/index.js


;// CONCATENATED MODULE: ./components/cms/CMS_CardImageText.js






var CMS_CardImageText = function(param) {
    var content = param.content;
    var router = (0,next_router.useRouter)();
    var handleClick = function() {
        if (content.button && content.button.link) src/* links.handleRedirect */.Ok.handleRedirect(content.button.link, router);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card, {
            cardInfo: content,
            handleBtnClick: handleClick
        })
    });
};
CMS_CardImageText.defaultProps = {};
CMS_CardImageText.propTypes = {
    content: prop_types.object.isRequired
};
/* harmony default export */ var cms_CMS_CardImageText = (/*#__PURE__*/react.memo(CMS_CardImageText));


/***/ }),

/***/ 94634:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__pXvvb","cardContent":"Card_cardContent__N7v5t","cardTitle":"Card_cardTitle__qRzJX","cardWrapper":"Card_cardWrapper__tpNTZ","category":"Card_category__3mS6O"};

/***/ }),

/***/ 12073:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.364 22a.345.345 0 01-.272-.14.46.46 0 01.03-.588L16.274 12l-9.15-9.27a.461.461 0 01-.032-.59c.07-.088.169-.14.273-.14a.34.34 0 01.24.104l9.152 9.272c.021.022.04.043.059.067.268.346.241.875-.058 1.18l-9.152 9.273a.338.338 0 01-.241.104z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronRightIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);